/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1ImagesheetpapersQueryResponse } from '../../types/GetV1Imagesheetpapers.ts'

export const getV1ImagesheetpapersQueryKey = () => [{ url: '/v1/ImageSheetPapers' }] as const

export type GetV1ImagesheetpapersQueryKey = ReturnType<typeof getV1ImagesheetpapersQueryKey>

/**
 * {@link /v1/ImageSheetPapers}
 */
export async function getV1Imagesheetpapers(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1ImagesheetpapersQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/ImageSheetPapers`, ...requestConfig })
    return res
}

export function getV1ImagesheetpapersQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ImagesheetpapersQueryKey()
    return queryOptions<
        ResponseConfig<GetV1ImagesheetpapersQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ImagesheetpapersQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Imagesheetpapers(config)
        },
    })
}

/**
 * {@link /v1/ImageSheetPapers}
 */
export function useGetV1Imagesheetpapers<
    TData = ResponseConfig<GetV1ImagesheetpapersQueryResponse>,
    TQueryData = ResponseConfig<GetV1ImagesheetpapersQueryResponse>,
    TQueryKey extends QueryKey = GetV1ImagesheetpapersQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ImagesheetpapersQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ImagesheetpapersQueryKey()

    const query = useQuery(
        {
            ...getV1ImagesheetpapersQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
